import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

import HistorySlider from "./HistorySlider";

function History() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/simage-1.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      <div class="container" style={{background:'white'}}>
        <div class="row">
          <div class="col-md-12">
            {/* <HistorySlider /> */}
            <div style={{ padding: '60px' }}>
              {/* <h3 className="historyheadeg">{t("history_h1")}</h3> */}

              <h3 className="historyheadeg">History</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                It was a decade after the historically famous installation of the Aruvippuram Temple by Sree Narayana Guru, that a proposal was formed to build a temple of Lord Shiva in Kozhikode. On Edavam 6th 1082 a meeting was held which was presided by Brahmasree Chaithanya Swamikal (one of the dignified disciples of Guru Deva) at Ikkiriparambathu Bhajanakovil (now the compound adjacent to R.D.O. Office). Many prominent members of the Thiya community participated in this meeting. As per the preliminary discussions, another meeting was called on 7th Dhanu 1083 at Native High school (now known as Ganapathi High school) presided by Sri. Kallingal Madhathil Rarichan Mooppan. Here the decision was made to construct the temple and a committee was formed with Sri. Rarichan Mooppan as president, to fulfill the task.
                {/* {t("history_h1_para")} */}
              </p>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                On 12th Dhanu 1083, the "Kutti Nattal" (the divine karma of marking the foundation of the temple) was accomplished by Sree Narayana Guru and he blessed the project. As advised by Guru Deva a temporary small temple was made for the devotees to worship.
              </p>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                After about eight months, on 2nd Chingam 1084 Brahmasree Chaithanya Swamikal laid the foundation stone for the temple of Lord Shiva. On the 16th of the same month he himself executed the installation of the Shadadhara. After that the construction of the temple progressed with immense help rendered by devotees and the community. The construction of the sub-temples of Lord Subrahmanya, Lord Ganapathi and Lord Dharma Shastha also progressed along with this.
              </p>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                On completion of the construction, Guru Deva suggested the "Muhoortham for the prathishtakarmam"(timing for the installation). The muhoortham was at the "Arunodayam" (sun rise) after the midnight of 29th Medam 1085 (11th May 1910). To give a divine bath, the Shivalinga was taken from Kallingal Kshetra (where it was made) at 12 :00 noon on 8th May to the sea shore on the western side of the Sree Varakkal Devi Kshetra, accompanied by a long procession. After the bath the idol was brought to the new temple and immersed in holy water prior to installation. People from all castes and creeds irrespective of the religion participated in the procession
As scheduled Sree Narayana Guru came to Kozhikode well before the Prathistha Muhoortham (timing of installation), the venue of the temple was crowded with devotees and public from various parts of the country. On Thursday the 12th of May 1910 at the most auspicious muhurtham at 5:30 A.M. the installation ceremony of Shivalinga was conducted by Sree Narayana Gurudevan with all the divine rituals. The installation of the Upadevas (Gods of the sub temples) followed thereafter. The prathista was named as "Sreekantheswara" by Gurudevan. Thus the temple is known as Sreekanteswara Kshetra
              </p>

              {/* <h3 className="historyheadeg">{t("history_h2")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h2_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h3")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h3_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h4")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h4_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h5")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h5_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h6")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h6_para")}
              </p>
              <ol className="hcontent" style={{ marginLeft: '25px' }}>
                <li>{t("1")}</li>
                <li>{t("2")}</li>
                <li>{t("3")}</li>
              </ol>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h6_2_para")}
              </p> */}

            </div>

          </div>
          

        </div>
      </div>
    </div>
  );
}

export default History;
